import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import AwardsList from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/awards_list.vue?vue3';
import { getMutation, optimisticAwardUpdate, getNewCustomEmojiPath } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/notes/award_utils.js?vue3';
export default {
    name: 'WorkItemNoteAwardsList',
    components: {
        AwardsList
    },
    props: {
        fullPath: {
            type: String,
            required: true
        },
        workItemIid: {
            type: String,
            required: true
        },
        note: {
            type: Object,
            required: true
        }
    },
    emits: [
        'error'
    ],
    computed: {
        awards () {
            return this.note.awardEmoji.nodes.map((award)=>{
                return {
                    ...award,
                    user: {
                        ...award.user,
                        id: getIdFromGraphQLId(award.user.id)
                    }
                };
            });
        },
        hasAwardEmojiPermission () {
            return this.note.userPermissions.awardEmoji;
        },
        customEmojiPath () {
            return getNewCustomEmojiPath({
                cache: this.$apollo.provider.clients.defaultClient,
                fullPath: this.fullPath,
                workItemIid: this.workItemIid
            });
        },
        currentUserId () {
            return window.gon.current_user_id;
        }
    },
    methods: {
        async handleAward (name) {
            if (!this.hasAwardEmojiPermission) {
                return;
            }
            const { mutation, mutationName, errorMessage } = getMutation({
                note: this.note,
                name
            });
            try {
                await this.$apollo.mutate({
                    mutation,
                    variables: {
                        awardableId: this.note.id,
                        name
                    },
                    optimisticResponse: {
                        [mutationName]: {
                            errors: []
                        }
                    },
                    update: optimisticAwardUpdate({
                        note: this.note,
                        name,
                        fullPath: this.fullPath,
                        workItemIid: this.workItemIid
                    })
                });
            } catch (error) {
                this.$emit('error', errorMessage);
                Sentry.captureException(error);
            }
        }
    }
};
